export const bulkPricingTable = {
  quantity: 'Quantity',
  price: 'Price',
  discount: 'Discount',
};

export const bulkPricing = {
  bulkPricingTable,
};
